module.exports = __webpack_public_path__ + "media/images/babysitting/cover-mobile@2x-aba299c5d2f42b533b6cc203834da498.jpg";